module.exports = __webpack_public_path__ + "img/docker.93a41e98.svg";